import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { VrViewer } from "../components/trace/VrViewer";
import { Globe, Loader2, Orbit, Play } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);
const fmt = (iso) => { if (!iso) return ""; const d = new Date(iso); const p = (n) => String(n).padStart(2, "0"); return `${p(d.getMonth() + 1)}/${p(d.getDate())}/${d.getFullYear()}`; };

/* 免登录 360 VR 分享页：业主 / 分包 / 设计部在浏览器直接查看云端全景 */
export default function VrShare() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [view, setView] = useState(null);
  const zh = (navigator.language || "").toLowerCase().startsWith("zh");
  useEffect(() => {
    axios.get(`${BACKEND}/api/public/vr/${token}`).then(({ data: d }) => setData(d)).catch((e) => setErr(e?.detailText || (zh ? "链接无效或已失效" : "Link invalid or expired")));
  }, [token, zh]);
  return (
    <div className="min-h-screen bg-[#0b1220] text-white" data-testid="vr-share-page">
      <div className="max-w-5xl mx-auto px-4 py-6 space-y-5">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-cyan-500/20 border border-cyan-400/40 flex items-center justify-center"><Orbit className="h-5 w-5 text-cyan-300" /></div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-cyan-300/80">ALIGCUS · Site 360 VR</p>
            <h1 className="text-lg sm:text-2xl font-bold" data-testid="vr-share-address" data-keep-title>{data?.address || (zh ? "现场 360 全景" : "Site 360 panoramas")}</h1>
          </div>
        </div>
        {err && <p className="rounded-xl bg-red-500/20 border border-red-400/40 px-4 py-3 text-sm" data-testid="vr-share-error">{err}</p>}
        {!data && !err && <p className="text-sm text-white/60 inline-flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" />{zh ? "加载中…" : "Loading…"}</p>}
        {data && data.items.length === 0 && <p className="text-sm text-white/60" data-testid="vr-share-empty">{zh ? "尚无全景内容" : "No 360 content yet"}</p>}
        {data && data.items.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="vr-share-grid">
            {data.items.map((it) => (
              <button key={it.id} type="button" onClick={() => setView(it)} className="group text-left rounded-2xl overflow-hidden border border-white/10 bg-white/5 hover:border-cyan-400/60 transition-colors" data-testid={`vr-share-item-${it.id}`}>
                <div className="aspect-[2/1] bg-black/40 relative">
                  {it.kind === "photo" && <img src={abs(it.url)} alt={it.filename || "360"} loading="lazy" className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform" />}
                  {it.kind !== "photo" && <div className="h-full w-full flex items-center justify-center text-white/70">{it.kind === "video" ? <Play className="h-8 w-8" /> : <Globe className="h-8 w-8" />}</div>}
                  <span className="absolute left-2 top-2 text-[10px] px-2 py-0.5 rounded-full bg-black/60">{it.kind === "photo" ? "360°" : it.kind === "video" ? (zh ? "全景视频" : "360 Video") : (zh ? "云端链接" : "Cloud link")}</span>
                  {(it.markers || []).length > 0 && <span className="absolute right-2 top-2 text-[10px] px-2 py-0.5 rounded-full bg-red-600" data-testid={`vr-share-markers-${it.id}`}>{it.markers.length} {zh ? "处风险标注" : "risk markers"}</span>}
                </div>
                <div className="px-3 py-2">
                  <p className="text-xs font-semibold truncate">{it.title || it.filename || it.url}</p>
                  <p className="text-[10px] text-white/50">{fmt(it.at)} · {zh ? "点击拖动查看 · 手机可开陀螺仪环视" : "Tap to explore · gyroscope on mobile"}</p>
                </div>
              </button>
            ))}
          </div>
        )}
        <p className="text-[10px] text-white/40">{zh ? "本页由 ALIGCUS 项目系统生成，仅供查看现场全景。" : "Generated by ALIGCUS for viewing site panoramas."}</p>
      </div>
      <VrViewer item={view} src={view ? abs(view.url) : null} zh={zh} onClose={() => setView(null)} />
    </div>
  );
}
